"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExitFee = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var __generated__1 = require("../../../../../../shared/api/kapi/v1/__generated__/");
var core_1 = require("../../../../../../shared/core");
var date_1 = require("../../../../../../shared/core/utils/date");
var constants_1 = require("../../../../constants");
var copy_1 = require("../../../../copy");
function ExitFee(_a) {
    var contractType = _a.contractType, isInRenewal = _a.isInRenewal, exitFee = _a.exitFee, contractEndDate = _a.contractEndDate, hasFutureContracts = _a.hasFutureContracts;
    var formattedExitFee = (0, core_1.major2DP)((0, core_1.majorToMinor)(exitFee.value, exitFee.currency));
    var formattedExitFeeChargeDate = (0, date_1.formatFullDate)((0, date_fns_1.subDays)(new Date(contractEndDate), constants_1.RENEWAL_PERIOD_DAYS));
    var _b = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _b.copy, Copy = _b.Copy;
    return (contractType === __generated__1.TariffType.Variable ? (copy('noExitFees')) : !isInRenewal ? (copy('exitFeeCharge', { formattedExitFee: formattedExitFee, formattedExitFeeChargeDate: formattedExitFeeChargeDate })) : hasFutureContracts === true ? (copy('noExitFees')) : (react_1.default.createElement(Copy, { copyKey: "noExitFeesRenewal" })));
}
exports.ExitFee = ExitFee;
